import { Pipe, PipeTransform } from '@angular/core';
import { Product } from '../classes';

@Pipe({
  name: 'productFilter'
})
export class ProductFilterPipe implements PipeTransform {

  transform(products: Product[], filter: string = null): Product[] {
    if(typeof(filter) !== 'string') return products;
    filter = filter.trim().toLowerCase();
    return products.filter(x => `${x.productnumber}${x.productservice}`.toLowerCase().indexOf(filter) > -1);
  }

}
